import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import getApiUrl from '../../actions/ConfigurationAction';
import { ApplicationState } from '../../store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { getStoreInfo } from '../../actions/EtaAction';
import { useOktaAuth } from "@okta/okta-react";
import EtaChart from './EtaChart';
import EtaTank from './EtaTank';
import useRequiredInput from '../../hooks/useRequiredInput';
import './Eta.scss';
import SiteInfo from './EtaSiteInfo';
import EtaGradiant from './EtaGradiant';
import { EtaState } from '../../store/EtaSlice';
import { useHistory } from 'react-router-dom';

const Eta = () => {
    const { authState } = useOktaAuth();
    const history = useHistory();
    const basePath = window.location.origin;
    const dispatch = useDispatch();
    const configData: any = useSelector((state: ApplicationState) => state.Configuration.data);
    const siteInfoData: EtaState = useSelector((state: ApplicationState) => state.Eta);
    const [maxVolume, setMaxVolume] = useState(0);
    const [userInfo, setUserInfo] = useState<null | any>(null);

    const {
        value: enteredName,
        isValid: enteredNameIsValid,
        hasError: nameInputHasError,
        valueChangeHandler: nameChangedHandler,
        inputBlurHandler: nameBlurHandler,
        reset: resetNameInput
    } = useRequiredInput((value) => value.trim() !== '');

    useEffect(() => {
        if (basePath !== '') {
            dispatch(getApiUrl(basePath));
        }
    }, []);

    //useEffect(() => {
    //    if (!authState || !authState.isAuthenticated) {
    //        // When user isn't authenticated, forget any user info
    //        setUserInfo(null);
    //    } else {
    //        setUserInfo(authState.idToken.claims);
    //        // You can also get user information from the `/userinfo` endpoint
    //        /*oktaAuth.getUser().then((info) => {
    //          setUserInfo(info);
    //        });*/
    //    }
    //}, [authState, oktaAuth]);


    useEffect(() => {
        if (!authState || !authState.isAuthenticated) {
            localStorage.removeItem('authenticated');
            history.push('/');
            setUserInfo(null);
        }
        else if (authState) {
            console.log(authState?.idToken?.claims);
            if (authState?.idToken?.claims?.cost_center) {
                //Store User
                setUserInfo(authState?.idToken?.claims?.cost_center);
            }
        }
    }, []);

    useEffect(() => {
        if (siteInfoData.tanks.length > 0) {
            setMaxVolume(Math.max.apply(Math, siteInfoData.tanks.map((t: any) => {
                return t.tankVolume
            })));
        }
    }, [siteInfoData]);

    let formIsValid = false;

    if (enteredNameIsValid) {
        formIsValid = true;
    }

    const onSubmitFormHandler = (event: any) => {
        event.preventDefault();

        if (!enteredNameIsValid) {
            return;
        }

        if (authState && authState.isAuthenticated && authState.accessToken) {
            var status = dispatch(getStoreInfo(configData.apiUrl, userInfo ?? enteredName, authState.accessToken));
            //if (!!status) {
            //    nameInputHasError: true; 
            //}
        }
    }

    const nameInputClasses = nameInputHasError
        ? 'formControl invalid mb-0'
        : 'formControl mb-0';

    return (
        <Fragment>
            <div className="row p-0 m-0 w-100 justify-content-center">
                <div className="dialogbox dialogbox-sm w-100">
                    <form onSubmit={onSubmitFormHandler}>
                        <div className={nameInputClasses}>
                            <label htmlFor="txtSearch">Store#</label>
                            <input type="search" id="txtSearch"
                                onChange={nameChangedHandler}
                                onBlur={nameBlurHandler}
                                value={userInfo ?? enteredName} />
                            {nameInputHasError && (
                                <p className='error-text mb-0'>Store# must not be empty.</p>
                            )}
                        </div>
                        <div className="formActions">
                            <button disabled={!formIsValid} type="submit"><FontAwesomeIcon icon={faSearch} /> Search</button>
                        </div>
                    </form>
                </div>
            </div>
            {
                siteInfoData.data.SiteCode !== '' && (
                    <Fragment>
                        <SiteInfo data={siteInfoData.data} />
                        <EtaGradiant />

                        <div className="row">
                            <EtaChart orders={siteInfoData.orders}/>
                            <EtaTank tanks={siteInfoData.tanks} maxValue={maxVolume} />
                        </div>
                    </Fragment>
                )
            }
        </Fragment>
    )
};

export default Eta;